define('components/videofactory/models/HTMLVideoModel', [

], function() {

    var HTMLVideoModel = Backbone.Model.extend({
        defaults: {
            viewId: "html-video-Id",            // Classic default viewId
            videoFile: null,                    // Path to video file
            videoWidth: '100%',                 // Width of video (could be in % or px)
            videoHeight: '100%',                // Height of video (could be in % or px)
            autoplay: false,                    // Autoplay video
            preload: true,                      // Preload or not video
            controls: true,                     // Show / Hide default html controls
            poster: null,                       // Show / Hide poster
            pluginPath: 'swf/',                 // Path of swf file directory
            subtitleLang: "fr",                 // Default subtitle language
            subtitleLabel: "Français",          // Default subtitle label
            subtitle: null,                     // Path of subtitles
            subtitleVTT: null,                  // Path of VTT subtitles
            currentTime: -1,                    // Current time of the video (in milliseconds)
            duration: -1,                       // Duration of the video (in milliseconds)
            onReady: null,                      // Callback when video is ready
            onPlay: null,                       // Callback when video is played
            onPause: null,                      // Callback when video is paused
            onEnded: null                       // Callback when video is ended
        }
    });

    return HTMLVideoModel;
});
